import {createEvent} from "./createEvent";

export const catalogEvents = {
    openCatalogFilter: createEvent<{filterKey: string}>(), // Нужно открыть модалку "Конкретный фильтр"
    closeCatalogFilter: createEvent(), // Нужно закрыть модалку "Конкретный фильтр"
    openCatalogFilters: createEvent(), // Нужно открыть модалку "Все фильтры"
    closeCatalogFilters: createEvent(), // Нужно закрыть модалку "Все фильтры"
};
